import React from 'react';
import DashboardLayout from '../../../shared/layout/DashboardLayout';
import ListEncoder from '../components/ListEncoder';

export default function EncoderListPage() {
  return (
    <DashboardLayout>
      <ListEncoder />
    </DashboardLayout>
  );
}
